import Axios from 'axios'

import { defaultResponse } from './response'

import { Urls, Strings, Events } from '../../../constants'

import {
    notifier,
    sendEvent,
    clone
} from '../../../utils'

const http = Axios.create({
    baseURL: Urls.ONLINE_URL,
    validateStatus: false
})

const requestConfig = (config) => {

    sendEvent(Events.SHOW_LOADING)

    if (config.data instanceof FormData) {

    } else if (config.data instanceof Object) {

    }

    return config
}

const requestConfigError = (error) => {

    sendEvent(Events.HIDE_LOADING)

    return Promise.reject(error)
}

const response = (response) => {

    let data = response.data

    if (! data) {

        data = clone(defaultResponse)

        data.error = Strings.ERROR_UNEXPECTED
    }

    if (! data.estado) {

        notifier.alert(data.error || Strings.ERROR_UNEXPECTED)
    }

    sendEvent(Events.HIDE_LOADING)

    return data
}

const responseError = (error) => {

    const data = clone(defaultResponse)

    data.error = `${Strings.ERROR_UNEXPECTED} ${error ? `[ ${error.toString()} ]` : ''}`

    sendEvent(Events.HIDE_LOADING)

    notifier.alert(data.error || Strings.ERROR_UNEXPECTED)

    return Promise.reject(data)
}

http.interceptors.request.use(requestConfig, requestConfigError)

http.interceptors.response.use(response, responseError)

export default http
